export enum CaseStatus {
  Active = 0,
  PleaBargained = 1,
  Dismissed = 2,
  TriedWon = 3,
  TriedLost = 4,
  Deleted = 5,
}

export enum OfficerCaseRole {
  Owner = 1, // Same as moderator + Set other owner
  Readonly = 2, // Read only (view) cases or files
  Reviewer = 3, // Read only (view) cases or files, comment, view audit and members
  Moderator = 4, // can do anything
}

export enum MemberType {
  User = 1,
  Guest = 2,
}
